export type MarketplaceSearchValues = {
    product?: string;
    supplier?: string;
    country?: string;
    categoryId?: string;
};

export const marketplaceSearchQuery = ({product, supplier, country, categoryId}: MarketplaceSearchValues) => {
    const params = new URLSearchParams();
    if (product?.trim()) params.set("product", product.trim());
    if (supplier?.trim()) params.set("supplier", supplier.trim());
    if (country?.trim()) params.set("country", country.trim());
    if (categoryId?.trim()) params.set("categoryId", categoryId.trim());
    return params.toString();
};

export const filterSearchOptions = (
    options: {id: string; label: string}[],
    query: string,
) => {
    const needle = query.trim().toLowerCase();
    if (!needle) return options;
    return options.filter((option) => option.label.toLowerCase().includes(needle));
};
